// Module
var code = "<svg width=\"30\" height=\"30\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.341 18.424a1 1 0 0 0 1.318 0l5.338-4.671c.695-.608.265-1.753-.658-1.753H9.66c-.923 0-1.353 1.145-.658 1.753l5.338 4.67z\"/> </svg>";
// Exports
module.exports = code;